import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-04758091"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mt-6 md:mt-10" }
const _hoisted_2 = { class: "container mx-auto" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title text-3xl lg:text-5xl" }, [
  /*#__PURE__*/_createElementVNode("p", null, "What are BBTF information NFTs and Tokens?"),
  /*#__PURE__*/_createElementVNode("p", null, "And why do we use them?")
], -1))
const _hoisted_4 = { class: "flex justify-around mt-16 md:mt-20 lg:flex-row flex-col" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "self-center order-2 md:order-1" }, [
  /*#__PURE__*/_createElementVNode("div", {
    style: {"font-size":"32px"},
    class: "font-extrabold px-4 mt-14 md:mt-2"
  }, [
    /*#__PURE__*/_createElementVNode("p", null, "BBTF will send NFTs to donors as a"),
    /*#__PURE__*/_createElementVNode("p", null, "means to inform the donors of their"),
    /*#__PURE__*/_createElementVNode("p", null, [
      /*#__PURE__*/_createTextVNode(" contribution "),
      /*#__PURE__*/_createElementVNode("span", { class: "text-primary-dark" }, "to save our planet.")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "text-xl text-gray-description mt-4 px-4" }, [
    /*#__PURE__*/_createElementVNode("p", null, " With each square foot of forest that has been planted via donation, "),
    /*#__PURE__*/_createElementVNode("p", null, "the donor will receive one Carbon NFT and one Life NFT.")
  ])
], -1))
const _hoisted_6 = { style: {"background":"#0a180e"} }
const _hoisted_7 = { class: "container mx-auto flex justify-around py-16 mt-16 lg:flex-row flex-col" }
const _hoisted_8 = { class: "lg:mx-0 mx-auto" }
const _hoisted_9 = /*#__PURE__*/_createStaticVNode("<div class=\"text-white lg:mx-0 mx-auto px-4\" data-v-04758091><div class=\"font-bold font-sarabun text-6xl md:text-7xl\" data-v-04758091><p class=\"mb-8\" data-v-04758091>Carbon NFT</p><p data-v-04758091>&amp; Life NFT</p></div><div class=\"mt-14\" data-v-04758091><p class=\"text-2xl font-semibold\" data-v-04758091>Carbon NFT</p><div class=\"line\" data-v-04758091></div><p data-v-04758091> For each square foot of forest planted, the donor will receive 1 carbon nft as the means to document their donation. </p></div><div class=\"mt-12\" data-v-04758091><p class=\"text-2xl font-semibold\" data-v-04758091>Life NFT</p><div class=\"line\" data-v-04758091></div><p data-v-04758091> For each square foot of forest planted, the donor will receive 1 life nft as the means to document their donation. </p></div></div>", 1)
const _hoisted_10 = { class: "container mx-auto px-4" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title text-3xl lg:text-5xl my-16" }, "Carbon Token & Life Token", -1))
const _hoisted_12 = {
  class: "lg:grid-cols-2 grid grid-cols-1 mx-auto",
  style: {"width":"fit-content","column-gap":"60px"}
}
const _hoisted_13 = { class: "token lg:mb-0 mb-8" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", { class: "name" }, "Carbon Token"),
  /*#__PURE__*/_createElementVNode("p", { class: "convert" }, "1 Carbon Token = 1 kg of CO2 sequestered"),
  /*#__PURE__*/_createElementVNode("div", { class: "description" }, " When the donor’s square meter of planted forest tree sequesters 1 kilogram of CO2, the donor will receive 1 carbon token to document that 1 kilogram of CO2 has been sequestered. The summary of carbon token received will be sent to the donor annually to show the donors the accumulated amount of CO2 sequestered as a result of their donation. ")
], -1))
const _hoisted_15 = { class: "token" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", { class: "name" }, "Life Token"),
  /*#__PURE__*/_createElementVNode("p", { class: "convert" }, " 1 Life Token = 1 wildlife supported by the forest "),
  /*#__PURE__*/_createElementVNode("div", { class: "description" }, " When the donor’s square meter of planted forest tree fosters a reproduction of a forest species, the donor will receive 1 life token to document that 1 living thing has been reproduced within that square meter of forest. The summary of life tokens received will be sent to the donor annually to show the donors the accumulated number of living things multiplied as a result of their donation. ")
], -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-center text-xl my-16 md:my-24" }, [
  /*#__PURE__*/_createTextVNode(" In case you were wondering, this is how we measure "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-primary-dark" }, "CO2 sequestration"),
  /*#__PURE__*/_createTextVNode(" and "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-primary-dark" }, " the number of wildlife"),
  /*#__PURE__*/_createTextVNode(" in our forest. ")
], -1))

import IconInformationNft from '@/components/Icons/IconInformationNft.vue';
import IconInformationNftCard from '@/components/Icons/IconInformationNftCard.vue';
import IconCoinCarbon from '@/components/Icons/IconCoinCarbon.vue';
import IconCoinLife from '@/components/Icons/IconCoinLife.vue';

export default /*#__PURE__*/_defineComponent({
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createVNode(IconInformationNft, { class: "lg:mx-0 mx-auto order-1 md:order-2 py-8 w-full max-w-xs md:max-w-xl mx-auto" })
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createVNode(IconInformationNftCard, { class: "w-full max-w-xl" })
        ]),
        _hoisted_9
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _hoisted_11,
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _createVNode(IconCoinCarbon, { class: "w-40 mx-auto -mt-28" }),
          _hoisted_14
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createVNode(IconCoinLife, { class: "w-40 mx-auto -mt-28" }),
          _hoisted_16
        ])
      ]),
      _hoisted_17
    ])
  ]))
}
}

})